/**
 * Types for Objects inside the Application
 */

export * from "./user"
export * from "./customerdata"
